export const technologyTranslations = {
  en: {
    headline: 'Our Technology',
    sections: [
      {
        title: '3D Motion Generation',
        content: 'AI-powered technology that generates lifelike animations and dynamic character movements from simple text prompts. It redefines how motion is created and integrated into digital systems.'
      },
      {
        title: 'Empathica Digital Human',
        content: 'Realistic virtual characters with expressive emotions and gestures. A new standard for creating emotionally responsive and relatable digital personas.'
      },
      {
        title: 'AI-Driven Contents Creation',
        content: 'Smart tools for seamless creation and optimization of digital content. Transforming creative workflows with precision and efficiency.'
      }
    ]
  },
  ko: {
    headline: '기술',
    sections: [
      {
        title: '3D 모션 생성',
        content: '간단한 텍스트 프롬프트만으로 생동감 있는 애니메이션과 역동적인 캐릭터 움직임을 생성하는 AI 기반 기술입니다. 모션이 생성되고 디지털 시스템에 통합되는 방식을 새롭게 정의합니다.'
      },
      {
        title: '엠패시카 디지털 휴먼',
        content: '표현력 있는 감정과 제스처를 갖춘 사실적인 가상 캐릭터입니다. 감정적으로 반응하고 공감할 수 있는 디지털 페르소나 제작의 새로운 기준을 제시합니다.'
      },
      {
        title: 'AI 기반 콘텐츠 제작',
        content: '디지털 콘텐츠의 원활한 제작과 최적화를 위한 스마트 도구입니다. 정밀성과 효율성으로 창작 워크플로우를 혁신합니다.'
      }
    ]
  },
  zh: {
    headline: '我们的技术',
    sections: [
      {
        title: '3D动作生成',
        content: '基于AI的技术，通过简单的文字提示生成逼真的动画和动态角色动作。重新定义动作创作及其在数字系统中的整合方式。'
      },
      {
        title: 'Empathica数字人物',
        content: '具有表现力丰富的情感和手势的真实虚拟角色。为创建具有情感响应能力和亲和力的数字形象树立新标准。'
      },
      {
        title: 'AI驱动内容创作',
        content: '用于无缝创建和优化数字内容的智能工具。以精确度和效率改变创意工作流程。'
      }
    ]
  },
  ja: {
    headline: '私たちの技術',
    sections: [
      {
        title: '3Dモーション生成',
        content: 'シンプルなテキストプロンプトから生命感あふれるアニメーションとダイナミックなキャラクターの動きを生成するAI駆動技術です。モーションの作成とデジタルシステムへの統合方法を再定義します。'
      },
      {
        title: 'エンパシカ デジタルヒューマン',
        content: '表現力豊かな感情とジェスチャーを備えたリアルなバーチャルキャラクター。感情的な応答性と親近感のあるデジタルペルソナ作成の新基準を確立します。'
      },
      {
        title: 'AI駆動コンテンツ制作',
        content: 'デジタルコンテンツのシームレスな制作と最適化のためのスマートツール。precision性と効率性でクリエイティブワークフローを変革します。'
      }
    ]
  }
};